/**
 * clickNavigation - Rowenta
 */

$(function() {
	$("[data-analytics-clickNavigation] a").on('click',function() {

		var nav = {};

		var level1 = "data-analytics-clickNavigation-navLevel1";
		var level2 = "data-analytics-clickNavigation-navLevel2";

		if ($(this).prop("href") != "javascript:void(0)") {

			if (clickNavigationSiblingExists($(this), level2)) {

				// Level 2
				nav.navLevel2 = getClickNavigationPropertyValue($(this), level2);

				// Level 1
				nav.navLevel1 = getClickNavigationPropertyValue($(this), level1);

				sendEvent('clickNavigation', nav);

			} else if ((!$(this).prop("href").includes("#")) && clickNavigationSiblingExists($(this), level1) || $(this).parent(".accordion-group").parent("ul").hasClass("navigation")) {

				// Level 1
				nav.navLevel1 = getClickNavigationPropertyValue($(this), level1);

				sendEvent('clickNavigation', nav);

			}

		}
	});
});

/**
 * addToComparator & ComparatorAccess event - Rowenta
 */

function analyticsComparator() {

	var array = [];

	var productID = "data-analytics-addToComparator-productID";
	var productName = "data-analytics-addToComparator-productName";

	/*
	 * addToComparator event - when the user presses the back button to this
	 * page (to circumvent browser cache)
	 */
	$("[data-analytics-addToComparator]:checked").each(function(index, element) {
		var id = getPropertyValue($(this), productID);
		var name = getPropertyValue($(this), productName);

		array.push({
			'productID' : id,
			'productName' : name
		});
	});

	/*
	 * addToComparator event - when the user refreshes the page / enters the
	 * page
	 */
	$("[data-analytics-addToComparator]").on('click',function() {

		var id = getPropertyValue($(this), productID);
		var name = getPropertyValue($(this), productName);

		var max = isMobile ? 2 : 4;
		if ($(this).is(':checked') && array.length < max) {

			var comparedProduct = {
				'productID' : id,
				'productName' : name
			}

			sendEvent('addToComparator', comparedProduct);

			array.push({
				'productID' : id,
				'productName' : name
			});

		} else {

			for (var i = 0; i < array.length; i++) {
				if (array[i].productID == id) {
					array.splice(i, 1);
					break;
				}
			}

		}

	});

	/*
	 * comparatorAccess event
	 */
	$("[data-analytics-comparatorAccess]").on('click', function() {

		var productCount = array.length;

		var products = {
			"productCount" : productCount
		};

		$.each(array, function(k, v) {
			k++;

			var customPropertyID = "product" + k + "ID";
			var customPropertyName = "product" + k + "Name";

			products[customPropertyID] = v.productID;
			products[customPropertyName] = v.productName;

		});

		sendEvent('ComparatorAccess', products);

	});
}

/**
 * exitLink event - Rowenta
 */

$(function() {

	$("a").on('click',function() {

		if (!$(this).hasClass("a2a_dd")) {

			var result = {};
			var socialMedias = [ "facebook", "youtube", "instagram", "addtoany", "twitter" ];
			var link = $(this).prop("href");
			var type = "others";

			for (i = 0; i < socialMedias.length; i++) {
				if (link.includes(socialMedias[i])) {
					type = "social";
					break;
				}
			}

			if (!window.location.href.includes(extractDomain(link)) && !extractDomain(link).includes("javascript") && !$(this).is("[data-analytics-whereToBuyRetailerLogo]")) {

				result.linkType = type;
				result.linkUrl = link;

				sendEvent('exitLink', result);

			}
		}

	});

});

/**
 * facetedSearch event - Rowenta
 */

$(function() {

	$("[data-analytics-facetedSearch]").on('click',function() {

		var facet = {};

		var facetType = "data-analytics-facetedSearch-facetType";
		var facetName = "data-analytics-facetedSearch-facetName";
		var facetValue = "data-analytics-facetedSearch-facetValue";

		if ($(this).is(":checked") || (!$(this).is("input[type='checkbox']") && !$(this).hasClass("active"))) {

			// facetType
			facet.facetType = getPropertyValue($(this), facetType);

			// facetName
			facet.facetName = getPropertyValue($(this), facetName);

			// facetValue
			facet.facetValue = getPropertyValue($(this), facetValue);

			sendEvent('facetedSearch', facet);

		}

	});

});

/**
 * socialShare event - Rowenta
 */

function socialShare(data) {

	var socialNetwork = data.service;
	var sharedURL = data.url;

	var socialShare = {
		"socialNetwork" : socialNetwork,
		"sharedURL" : sharedURL
	};

	sendEvent('socialShare', socialShare);
};

/**
 * documentDownload event - Rowenta
 */

$(function() {

	$("[data-analytics-documentationDownload]").on('click',function() {

		var documentationType = "data-analytics-documentationDownload-documentationType";
		var documentationProduct = "data-analytics-documentationDownload-documentationProduct";

		var type = getPropertyValue($(this), documentationType);
		var product = getPropertyValue($(this), documentationProduct);

		var documentObj = {
			"documentationType" : type,
			"documentationProduct" : product
		};

		sendEvent('documentationDownload', documentObj);

	});

});

/**
 * FAQ event - Rowenta
 */

$(function() {

	$('[data-analytics-FAQ]').on('click',function() {

		if (!$(this).hasClass("active")) {

			var faqTopic = "data-analytics-FAQ-faqTopic";
			var faqQuestion = "data-analytics-FAQ-faqQuestion";

			var topic = getPropertyValue($(this), faqTopic);
			var question = getPropertyValue($(this), faqQuestion);

			var faq = {
				'faqTopic' : topic,
				'faqQuestion' : question
			};

			sendEvent('FAQ', faq);
		}

	});

});

/**
 * video event - Rowenta
 */

var gtmYTListeners = [];

/*
 * Returns whether a youtube video has been found or not
 */
function isYTVideoFound() {

	var youtubeVideoFound = false;

	for (var e = document.getElementsByTagName("iframe"), x = e.length; x--;) {
		if (/youtube.com\/embed/.test(e[x].src)) {
			if (e[x].src.indexOf('enablejsapi=') === -1) {
				e[x].src += (e[x].src.indexOf('?') === -1 ? '?' : '&') + 'enablejsapi=1';
			}
			youtubeVideoFound = true;
		}
	}

	return youtubeVideoFound;
}

/*
 * Activates YT API when a youtube video is found
 */
function activateYTListenerForAnalytics() {
	if ($("#youtube_api").length <= 0) {
		var j = document.createElement("script"), f = document.getElementsByTagName("script")[0];
		j.src = "//www.youtube.com/iframe_api";
		j.async = true;
		j.id = "youtube_api";
		f.parentNode.insertBefore(j, f);
	} else {
		onYouTubeIframeAPIReady()
	}
}

/*
 * Detects state changes (Play/Pause)
 */
function onYouTubeIframeAPIReady() {
	for (var e = document.getElementsByTagName("iframe"), x = e.length; x--;) {
		if (/youtube.com\/embed/.test(e[x].src)) {
			gtmYTListeners.push(new YT.Player(e[x], {
				events : {
					onStateChange : onPlayerStateChange
				}
			}));
			YT.gtmLastAction = "p";
		}
	}
}

/*
 * Detects state changes (Play/Pause)
 */
function onPlayerStateChange(e) {
	e["data"] == YT.PlayerState.PLAYING && setTimeout(onPlayerPercent, 1000, e);
	var video_data = e.target["getVideoData"]();
	if (e["data"] == YT.PlayerState.PLAYING && YT.gtmLastAction == "p") {

		sendEvent("video", {
			"videoName" : video_data.title,
			"videoAction" : 'Play',
			"videoProgress" : onPlayerPercent(e)
		});
		YT.gtmLastAction = "";
	}
	if (e["data"] == YT.PlayerState.PAUSED) {

		sendEvent("video", {
			"videoName" : video_data.title,
			"videoAction" : 'Pause',
			"videoProgress" : onPlayerPercent(e)
		});
		YT.gtmLastAction = "p";

	}
}

/*
 * Detects video progress
 */
function onPlayerPercent(e) {
	var duration = e.target["getDuration"]();
	var currentTime = e.target["getCurrentTime"]();
	var t = duration - currentTime <= 1.5 ? 1 : (Math.floor(currentTime / duration * 4) / 4).toFixed(2);
	if (!e["lastP"] || t > e["lastP"]) {
		e["lastP"] = t;
		var progress = t * 100 + "%";
	}
	e["lastP"] != 1 && setTimeout(onPlayerPercent, 1000, e);

	return progress;
}

/*
 * event trigger
 */
$(function() {
	var youtubeVideoFound = isYTVideoFound();
	if (youtubeVideoFound) {
		activateYTListenerForAnalytics();
	}
});

/**
 * buyOnlineButton event - Moulinex
 */

$(function() {

	$("[data-analytics-buyOnlineButton]").on("click", function(e) {

		var productID = "data-analytics-buyOnlineButton-productID"
		var productName = "data-analytics-buyOnlineButton-productName"
		var productPrice = "data-analytics-buyOnlineButton-productPrice"

		var id = getPropertyValue($(this), productID);
		var name = getPropertyValue($(this), productName);
		var price = getPropertyValue($(this), productPrice);

		var product = {
			'productID' : id,
			'productName' : name,
			'productPrice' : price

		};

		sendEvent('buyOnlineButton', product);

	});

});

/**
 * whereToBuyButton event - Rowenta
 */
$(function() {

	$("[data-analytics-whereToBuyButton]").on("click", function(e) {

		var productID = "data-analytics-whereToBuyButton-productID"
		var productName = "data-analytics-whereToBuyButton-productName"
		var productPrice = "data-analytics-whereToBuyButton-productPrice"

		var id = getPropertyValue($(this), productID);
		var name = getPropertyValue($(this), productName);
		var price = getPropertyValue($(this), productPrice);

		var product = {
			'productID' : id,
			'productName' : name,
			'productPrice' : price

		};

		sendEvent('whereToBuyButton', product);

	});

});

/**
 * buyOfflineButton - Rowenta
 */

$(function() {
	$("[data-analytics-buyOfflineButton]").on("click", function(e) {

		var productID = "data-analytics-buyOfflineButton-productID"
		var productName = "data-analytics-buyOfflineButton-productName"
		var productPrice = "data-analytics-buyOfflineButton-productPrice"

		var id = getPropertyValue($(this), productID);
		var name = getPropertyValue($(this), productName);
		var price = getPropertyValue($(this), productPrice);

		var product = {
			'productID' : id,
			'productName' : name,
			'productPrice' : price

		};

		sendEvent('buyOfflineButton', product);

	});
});

/**
 * buyOnlineRetailerLogo - Rowenta
 */

/*
 * event trigger
 */
$(function() {
	$("[data-analytics-buyOnlineRetailerLogo]").on("click", function() {
		fetchProductAndSendEvent($(this));
	});
});

function fetchProductAndSendEvent(element) {

	var productID = "data-analytics-buyOnlineRetailerLogo-productID";
	var productPrice = "data-analytics-buyOnlineRetailerLogo-productPrice";
	var productName = "data-analytics-buyOnlineRetailerLogo-productName";
	var retailerName = "data-analytics-buyOnlineRetailerLogo-retailerName";

	var id = getPropertyValue(element, productID);
	var price = getPropertyValue(element, productPrice);
	var name = getPropertyValue(element, productName);
	var retailer = getPropertyValue(element, retailerName);

	var product = {
		"productID" : id,
		"productName" : name,
		"productPrice" : price,
		"retailerName" : retailer
	}

	sendEvent("buyOnlineRetailerLogo", product);

}

/**
 * whereToBuyRetailerLogo event - Rowenta
 */
$(function() {

	$('[data-analytics-whereToBuyRetailerLogo]').on('click',function(event) {

		var retailerName = "data-analytics-whereTobuyRetailerLogo-retailerName";

		var name = extractDomain(getPropertyValue($(this), retailerName)).replace("www.", "");

		var retailer = {
			'retailerName' : name
		};

		if ($("body").hasClass("template-pages-storeFinder-storeFinderOnLinePage")) {
			sendEvent('whereToBuyRetailerLogo', retailer);
		}

	});

});

/**
 * newsletterSubscription event - Rowenta TODO: newsletterSubscription
 */
$(function() {

	$("[data-analytics-newsletterSubscription]").on('click', function(e) {

		var ajaxURL = "data-analytics-newsletterSubscription-ajaxURL";
		var email = "data-analytics-newsletterSubscription-email";
		var external = "data-analytics-newsletterSubscription-isExternal";

		var subscriptionForm = '';

		var forms = [ '#newsLetterSubscriptionForm', '#command', '#FormNewsLetter', '#FormNewsLetter-myspace' ];

		for (i = 0; i < forms.length; i++) {
			if ($(forms[i]).length > 0) {
				subscriptionForm = $(forms[i]);
				break;
			}
		}

		var loggedUserEmail = getPropertyValue($(this), email);

		var isExternal = getPropertyValue($(this), external);

		if(isExternal){

			var email = $("#newsLetterSubscriptionForm").find("[name='e-mail']").first().val();
			var firstName = $("#newsLetterSubscriptionForm").find("[name='first-name']").first().val();
			var lastName = $("#newsLetterSubscriptionForm").find("[name='last-Name']").first().val();

			if(email.length > 0 && firstName.length > 0 && lastName.length > 0 && isEmail(email)){
				sendEvent("newsletterSubscription", {"email" : email});
			}

		} else if (loggedUserEmail.length > 0) {

			if (subscriptionForm.is("#command") || $("input.radio-newsletter:checked").val() == 'oui') {

				sendEvent("newsletterSubscription", {
					"email" : loggedUserEmail
				});

			} else if(subscriptionForm.is("#newsLetterSubscriptionForm")){
				$.ajax({
          url: getPropertyValue($(this), ajaxURL),
          type: "POST",
          data: subscriptionForm.serialize(),
          async: false
        }).done(function(result) {

          if (result.length > 0) {
            sendEvent("newsletterSubscription", {
              "email" : result
            });
          }

        });

				subscriptionForm.trigger('submit');

			}

		} else if (!subscriptionForm.is("#command")) {

			e.preventDefault();

			if (subscriptionForm.length > 0) {
				$.ajax({
          url: getPropertyValue($(this), ajaxURL),
          type: "POST",
          data: subscriptionForm.serialize(),
          async: false
        }).done(function(result) {

          if (result.length > 0) {
            sendEvent("newsletterSubscription", {
              "email" : result
            });
          }

        });
			}

			subscriptionForm.trigger('submit');

		}

	});

});

/**
 * burgerMenuClick event - Rowenta
 */

$(function() {

	$("[data-analytics-burgerMenuClic]").on('click',function() {

		if ($(this).hasClass('active')) {
			sendEvent('burgerMenuClic', {});
		}

	});

});

/**
 * printPage event - Rowenta
 */
$(function() {

	$("[data-analytics-printPage]").on('click',function() {
		sendEvent('printPage', {});
	});

});

/**
 * faqFeedback event - Rowenta
 */

$(function() {

	$("[data-analytics-faqFeedback]").on('click',function() {

		var faqTopic = "data-analytics-faqFeedback-faqTopic";
		var faqQuestion = "data-analytics-faqFeedback-faqQuestion";
		var faqFeedback = "data-analytics-faqFeedback-satisfaction";

		var topic = getPropertyValue($(this), faqTopic);
		var question = getPropertyValue($(this), faqQuestion);
		var feedback = $(this).siblings("[" + faqFeedback + "]").find("input[name='notation']:checked").val() == "true" ? "yes" : "no";

		var faq = {
			'faqTopic' : topic,
			'faqQuestion' : question,
			'faqFeedback' : feedback
		};

		sendEvent('faqFeedback', faq);

	});

});

/**
 * productListSorting event - Rowenta
 */

$(function() {

	$("[data-analytics-productListSorting]").on('change',function() {

		var sortName = $(this).find("option:selected").text().trim();
		var sort = {
			"sortBy" : sortName
		};

		sendEvent('productListSorting', sort);

	});

});

/**
 * accountCreation event - Rowenta TODO: Fix accountCreation
 */

$(function() {
	$("[data-analytics-accountCreation]").on('click', function(e) {

		var ajaxURL = "data-analytics-accountCreation-ajaxURL";

		var registerForm = $("#FormCreateProfile").serialize();
		var url = getPropertyValue($(this), ajaxURL);

		$.ajax({
      type: "POST",
      data: registerForm,
      url: url,
      async: false
    }).done(function(result) {

      if (result.length > 0 && grecaptcha.getResponse().length > 0) {

        sendEvent("accountCreation", {
          "gender" : result == 'Mr' ? 'Man' : 'Woman'
        });

      }
    }).always(function(jqXHR, textStatus) {

      $(this).trigger('submit');

    });

	});
});

/**
 * newPasswordRequest event - Rowenta
 */

$(function() {

	$("[data-analytics-newPasswordRequest]").on('click',function() {

		var ajaxURL = "data-analytics-newPasswordRequest-ajaxURL";

		var formEmail = $("#ForgottenPassword input[name='email']").val();

		$.ajax({
      type: "POST",
      data: {
        "email": formEmail
      },
      url: getPropertyValue($(this), ajaxURL),
      crossDomain: true
    }).done(function(result) {
      if (result) {
        console.log(result);
        sendEvent("newPasswordRequest", {});
      }
    });

	});

});

/**
 * contactFormSubmit event - Rowenta
 */
$(function() {
	$("[data-analytics-contactFormSubmit]").on('click', function() {
		validateContactFormSubmit($("[data-analytics-contactFormSubmit-form]"));
	});
});

function validateContactFormSubmit(element) {
	var valid = element.validationEngine('validate');
	if (valid) {
		sendEvent('contactFormSubmit', {});
	}
}

/**
 * clickThumbnail event - Rowenta TODO: Thumbnail
 */

function clickThumbnail() {

	$("[data-analytics-clickThumbnail]").on('click',function() {

		var productCode = "data-analytics-clickThumbnail-productCode";
		var productIndex = "data-analytics-clickThumbnail-index";
		var ajaxURL = "data-analytics-clickThumbnail-ajaxURL";

		var code = getPropertyValue($(this), productCode);
		var index = getPropertyValue($(this), productIndex);
		var url = getPropertyValue($(this), ajaxURL);

		var params = {
			"productCode" : code
		};

		$.ajax({
			url : url,
			type : "POST",
			data : params,
			async : false
		}).done(function(result) {

      var marketingRange = result.type != null && result.type.code == 'RANGE' ? result.code : "N/A";
      var marketingCategory = result.categoryPaths.length > 0 ? result.categoryPaths[0] : "N/A";
      var marketingSubCategory = result.categoryPaths.length > 1 ? result.categoryPaths[1] : "N/A";

      var product = {
        'position' : index,
        'productID' : result.code,
        'productName' : result.name,
        'marketingCategory' : marketingCategory,
        'marketingSubcategory' : marketingSubCategory,
        'sisCategory' : result.sisCategory,
        'sisSubcategory' : result.sisSubCategory,
        'marketingRange' : marketingRange,
        'productType' : result.isAccessory ? "Accessory" : "Product",
        'productPrice' : result.price != null ? result.price.value : 'N/A',
        'productCurrency' : result.price != null ? result.price.currencyIso : 'N/A'
      };

      sendEvent('clickThumbnail', product);

    });
	});

}

/**
 * clickAddToCart event - Rowenta
 */
$(function() {
	$("[data-analytics-clickAddToCart]").on('click',function() {

		var productCode = "data-analytics-clickAddToCart-productCode";
		var productQuantity = "data-analytics-clickAddToCart-productQuantity";
		var ajaxURL = "data-analytics-clickAddToCart-ajaxURL";

		var code = getPropertyValue($(this), productCode);
		var quantity = $("[" + productQuantity + "]").find("input[name='qty']").val();
		var url = getPropertyValue($(this), ajaxURL);

		var params = {
			"productCode" : code
		};

		$.ajax({
      url: url,
      type: "POST",
      data: params
    }).done(function(result) {

      var marketingRange = result.type != null && result.type.code == 'RANGE' ? result.code : "N/A";
      var marketingCategory = result.categoryPaths.length > 0 ? result.categoryPaths[0] : "N/A";
      var marketingSubCategory = result.categoryPaths.length > 1 ? result.categoryPaths[1] : "N/A";

      var product = {
        'productID' : result.code,
        'productName' : result.name,
        'marketingCategory' : marketingCategory,
        'marketingSubcategory' : marketingSubCategory,
        'sisCategory' : result.sisCategory,
        'sisSubcategory' : result.sisSubCategory,
        'marketingRange' : marketingRange,
        'productType' : 'Accessory',
        'productPrice' : result.price != null ? result.price.value : 'N/A',
        'productQuantity' : $("[" + productQuantity + "]").find("input[name='qty']").length > 0 ? quantity : 1,
        'productCurrency' : result.price != null ? result.price.currencyIso : 'N/A',
        'pageType': _capitalize(tc_vars.page_type.replaceAll("."," "))
      };

      sendEvent('clickAddToCart', product);

    });

	});
});

//tC.event.clickCartCrossSellAdd
$(function () {
  $("[data-analytics-clickCartCrossSellAdd]").on('click', function () {
    var productCode = "data-analytics-clickCartCrossSellAdd-productCode";
    var ajaxURL = "data-analytics-clickCartCrossSellAdd-ajaxURL";
    var code = getPropertyValue($(this), productCode);
    var url = getPropertyValue($(this), ajaxURL);

    var params = {
      "productCode": code
    };
    $.ajax({
      url: url,
      type: "POST",
      data: params
    }).done(function (result) {

      var product = {
        'productName': result.name,
        'productID': result.code
      };

      sendEvent('clickCartCrossSellAdd', product);

    });
  });
});

/**
 * Rich autocomplete event - Rowenta
 */
$(function(){
    $(document).on("click", "[data-analytics-autosuggest]", function(){

        var container = $(".autocomplete-body");

        var action = getPropertyValue($(this), "data-analytics-autosuggest-action");
        var label = getPropertyValue(container, "data-analytics-autosuggest-label");
        var nbrResults = getPropertyValue(container, "data-analytics-autosuggest-nbrresults");

        var result = {
            "autosuggest_category":"internal_search",
            "autosuggest_label":label,
            "autosuggest_value":nbrResults,
            "autosuggest_action":action
        }

        sendEvent("autosuggest", result);
    });
});

//tC.event.chatClick
$(function () {
  $("[data-analytics-chatClick]").on('click', function () {
    var chatAction = getPropertyValue($(this), "data-analytics-chatClick-chatAction");

    if (typeof chatAction !== 'undefined' && chatAction !== false) {
      var result = {
        'chatAction': chatAction
      };

      $(this).removeAttr("data-analytics-chatClick-chatAction");
      sendEvent("chatClick", result);
    }
  });
});

setTimeout(function () {
	clickThumbnail();
	analyticsComparator();
}, 2000);
